module.exports = __webpack_public_path__ + "static/media/s_bar7.1f8163c4.svg";